module.exports = __webpack_public_path__ + "img/fig13.6eaec102.jpg";